// extracted by mini-css-extract-plugin
module.exports = {"error":"FormErrorBag_error__Uc4Lv","border":"FormErrorBag_border__KfBld","message":"FormErrorBag_message__4NMQo"};